import NavigateNext from '@mui/icons-material/NavigateNext';

export default NavigateNext;
